import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hhm5ztnc4f: FaireBrandEntity = {
  token: "b_hhm5ztnc4f",
  type: "brand",
  name: "Good Olfactory Candles",
  avatarUrl:
    "https://cdn.faire.com/fastly/e15d2e2e62a221d4a62d4988a0183e03a8613e590fd6beb3fc11d08874939356.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/94e4d916a44cb111a418aaea910e0e2d848caf5879eca6c8d6ec75f65b792a54.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e15d2e2e62a221d4a62d4988a0183e03a8613e590fd6beb3fc11d08874939356.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/94e4d916a44cb111a418aaea910e0e2d848caf5879eca6c8d6ec75f65b792a54.jpeg",
  location: "Seattle, WA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "At Good Olfactory, we believe self-care lives in the little things. Our hand-crafted candles and body goods turn everyday rituals into moments of kindness—gentle reminders to slow down, reset, and savor what matters.\n\nWe create thoughtful, everyday luxuries that support your well-being by making the simple act of caring for yourself feel intentional and restorative. Each product is crafted to bring a sense of ease into your routine, helping you feel grounded, refreshed, and connected to yourself.\n\nBecause you deserve simply good things.",
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:42.497Z",
    importedBy: "entity-db-cli",
  },
};
